// Utility function to remove commas from a formatted amount
export default function removeCommas(amount) {
  return amount.replace(/,/g, "");
}
